export type StringBoolean = 'yes' | 'no';

export const YES: StringBoolean = 'yes';
export const NO: StringBoolean = 'no';
